import React from 'react';
import { Button } from '@components/main-components/button/Button';
import { Modal } from '@components/main-components/modals/Modal';
import { ModalContext } from '@context/modal';
import { NAV_LINKS } from '@utils/constants';

const REJECTED_MESSAGE =
  "Thanks for your interest! We weren't able to verify your identity. Please apply again or email us at gm@sound.xyz if you believe this was done in error.";

export const ApplicationRejected = ({ closeNav }: { closeNav?: () => void }) => {
  const { closeCancelModal } = ModalContext.useContainer();

  const body = (
    <div className="relative flex w-full flex-col items-center justify-center gap-y-6">
      <div className="flex flex-col items-center justify-center gap-y-4 text-center">
        <div className="flex max-w-xs flex-col gap-y-4 font-base text-base800">
          <h2 className="text-base-l font-semibold md:text-base-xl">Artist Application denied!</h2>
          <p className="text-base-m md:text-base-l">{REJECTED_MESSAGE}</p>
        </div>
      </div>

      <div className="flex w-full items-center justify-center gap-x-2  ">
        <Button
          href={NAV_LINKS.ArtistApplication}
          label="Reapply"
          variant="primary"
          className="min-w-[unset] max-w-[unset]"
          onClick={() => {
            if (!!closeNav) {
              closeNav();
            }
          }}
        />
      </div>
    </div>
  );

  return <Modal body={body} closeModal={closeCancelModal} />;
};
